import * as faceapi from "face-api.js";

let modelsLoaded = false;

export const loadFaceApiModels = async (basePath = "/models") => {
  if (modelsLoaded) return;

  await Promise.all([
    faceapi.nets.ssdMobilenetv1.loadFromUri(basePath),
    faceapi.nets.faceLandmark68Net.loadFromUri(basePath),
    faceapi.nets.faceRecognitionNet.loadFromUri(basePath),
    faceapi.nets.tinyFaceDetector.loadFromUri(basePath),
    faceapi.nets.faceLandmark68TinyNet.loadFromUri(basePath),
  ]);

  modelsLoaded = true;
  console.log("✅ All face-api models loaded");
};

export const disposeFaceApiModels = () => {
  if (!modelsLoaded) {
    console.warn("⚠️ Models not loaded yet, skipping dispose");
    return;
  }

  Object.values(faceapi.nets).forEach((net) => {
    if (net && typeof net.dispose === "function" && net.params) {
      net.dispose();
    }
  });

  modelsLoaded = false;
  console.log("🧹 All face-api models disposed");
};
